import React from 'react'

const Manual_proveedores_gestionar_proveedores = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Proveedores - Gestionar Proveedores
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía ayuda a gestionar eficientemente la base de datos de proveedores mediante un proceso detallado para registrar nueva información con precisión. Permite optimizar compras, mejorar la comunicación y ofrece funciones opcionales para una gestión más eficiente, siendo un recurso valioso para las empresas.
        </p>
        <iframe
          src="https://scribehow.com/embed/Proveedores__Gestionar_Proveedores__CF82wfOYQ-qkaQRidg0TQQ?as=scrollable"
          className="scribe-iframe-general-35"
          width="100%"
          height="3750"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_proveedores_gestionar_proveedores